import {
  OfferDetailItem,
  Question,
} from '@sky-distribution/onboarding-commons-ui/lib/ItemDetailsModal/ItemDetailsModal.types';
import { TFunction } from 'i18next';

export const updateCoverageInfoModalQuestions = (
  infoModalQuestions: Question[],
  chosenTermValue: string,
  t: TFunction,
): Question[] => {
  const question = {
    name: t('CoverageInfoModal.CoverageQuestionNames.InsuredSum'),
    answer: [
      {
        type: 'p',
        content: `${chosenTermValue}`,
      },
    ],
  };

  return [question, ...infoModalQuestions];
};

export const translateCoveragePlans = (coverageInfoModalDetails: OfferDetailItem[], t: TFunction) => (
  coverageInfoModalDetails.map((offerDetailItem) => ({
    ...offerDetailItem,
    additionalDescription: t(offerDetailItem.additionalDescription as string),
  })));

export const updateCoverageInfoModalDetails = (
  coverageInfoModalDetails: OfferDetailItem | OfferDetailItem[],
  formattedPrice: string | undefined,
  t: TFunction,
): OfferDetailItem | OfferDetailItem[] => {
  if (Array.isArray(coverageInfoModalDetails) || !formattedPrice) {
    return coverageInfoModalDetails;
  }

  return {
    ...coverageInfoModalDetails,
    questions: updateCoverageInfoModalQuestions(coverageInfoModalDetails.questions, formattedPrice, t),
  };
};

export const getInitialSelectedPlanIndex = (
  modalDetails: OfferDetailItem | OfferDetailItem[],
  t: TFunction,
  chosenTermValue?: string,
) => {
  const defaultSelectedPlanIndex = 0;

  if (!Array.isArray(modalDetails) || !chosenTermValue) {
    return defaultSelectedPlanIndex;
  }

  const chosenTermIndex = translateCoveragePlans(modalDetails, t)
    .findIndex((offerItem) => offerItem.additionalDescription === chosenTermValue);

  return chosenTermIndex >= 0 ? chosenTermIndex : defaultSelectedPlanIndex;
};

export const getOriginalCoverageOptionCodeById = (originalModalDetails: OfferDetailItem[], id: string) => {
  const originalDetails = originalModalDetails.find((offerDetails) => offerDetails.id === id);

  return originalDetails?.additionalDescription;
};

export const formatModalDetails = (
  modalDetails: OfferDetailItem | OfferDetailItem[] | undefined,
  formatPrice: string | undefined,
  t: TFunction,
): OfferDetailItem | OfferDetailItem[] | undefined => {
  if (!modalDetails) {
    return undefined;
  }

  return updateCoverageInfoModalDetails(modalDetails, formatPrice, t);
};
